import React from 'react';
import '../../index.css'; // Assume CSS styles are saved in this file

const FastFoodExample = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">Use Case Description - Fast Food (Suitable for call-and-pick-up scenarios, such as burger joints, bubble tea shops, etc.)</h1>

      <div className="section">
        <p className="store-info">Tealicious is a chain bubble tea shop similar to Mixue Bingcheng, CoCo, and Shuyi Burn Fairy Grass, with the following service process:</p>
        <ol>
          <li>Customers order at the counter or scan a QR code on their phones to place orders and complete payment.</li>
          <li>The counter prints a receipt for the customer while the kitchen prints an order ticket simultaneously.</li>
          <li>After the kitchen prepares the order, the staff call the number, and the customer picks up the meal with the ticket.</li>
        </ol>
        <p>In addition, the client has the following requirements:</p>
        <ol>
          <li>Membership registration, offering a promotion where recharging $1000 gives an additional $300 for returning customers.</li>
          <li>Tax requirements, needing the system to automatically calculate taxes and display them on the receipt.</li>
          <li>Certain dishes are only available on weekend mornings and should automatically be removed from the menu after this time.</li>
          <li>The restaurant has several partners who wish to view the restaurant's financials.</li>
          <li>Need to export order details for further data analysis.</li>
        </ol>
      </div>

      <p>
        After understanding user needs, we proposed the following solutions:
      </p>

      <div className="section">
        <h2>Role Distribution</h2>
        <ol>
          <li>The manager logs into their mobile account to manage restaurant settings and view reports but does not directly handle orders. {/*[follow with a screenshot]*/}</li>
          <img src="./quick/img_11.png"  alt="" style={{width: '400px'}} />
          <li>Staff log into the cashier account on a computer, which is responsible for connecting to printers and handling orders, such as placing orders, settling bills, and printing receipts. {/*[follow with a screenshot]*/}</li>
          <img src="./quick/img_12.png"  alt="" style={{width: '400px'}} />
          <li>Partners log into their partner account on their mobile phones, which allows them to view the restaurant's business information but does not allow them to modify settings or handle orders. {/*[follow with a screenshot]*/}</li>
          <img src="./quick/img_13.png"  alt="" style={{width: '400px'}} />
        </ol>
      </div>

      <div className="section">
        <h2>Printer Settings</h2>
        <p>A cashier printer is deployed at the counter to print cashier receipts for customers, and a printer is deployed in the kitchen.</p>
        {/*[insert screenshots of printer settings and receipts]*/}
        <img src="./quick/img_4.png"  alt="" />
        <img src="./quick/img_5.png"  alt="" />

      </div>

      <div className="section">
        <h2>Membership Settings</h2>
        <p>Membership settings include storing rules, with both the counter and waitstaff able to assist customers with storing value.</p>
        <img src="./quick/img_14.png"  alt="" style={{width: '1000px'}} />
        <img src="./quick/img_15.png"  alt="" />
        {/*[insert settings screenshots]*/}
      </div>

      <div className="section">
        <h2>Tax Settings</h2>
        {/*[insert screenshots of tax settings, checkout page, and receipt images]*/}
      </div>

      <div className="section">
        <h2>Time-Specific Menu</h2>
        <p>Set certain dishes to only appear on Sunday mornings.</p>
        {/*<img src="./quick/img_7.png"  alt="" />*/}
        <img src="./quick/img_17.png" style={{maxWidth: "1400px"}} alt="" />
        {/*[insert settings screenshot]*/}
      </div>

      <div className="section">
        <h2>Export Orders</h2>
        <p>Facilitates in-depth analysis of sales data by restaurant partners and managers.</p>
        {/*[insert Excel screenshot]*/}
      </div>

      <div className="section">
        <h2>Kitchen Display System (KDS)</h2>
        <p>In addition to receiving order information through printed tickets, we also support the use of a Kitchen Display System (KDS) to display orders in the kitchen, allowing chefs to more clearly understand the order situation.
          <a href="link_to_kds_details">Click here for more details</a>.</p>
        <img src="./quick/img_9.png"  alt="" />
        {/*[insert an illustrative photo of the KDS, such as from a fast-food restaurant like McDonald's]*/}
      </div>

      {/*[Additional sections can be added here based on actual content needs]*/}

    </div>
  );
};

export default FastFoodExample;
